import { createContext } from 'react'

export default createContext({
  smallMinBreakpoint: 'xs',
  largeMinBreakpoint: 'lg'
})
